import React from 'react';
import { useTranslation } from 'react-i18next';

import LoadingButton from '../../common/LoadingButton';
import {
  DirectDepositBanner,
} from '../../myAccount/reimbursement/directDepositBanner';

import addIcon from '../../../assets/policy/add-white.svg';

import styles from './Reimbursement.module.css';
import { MARKETING_CHANNEL_ID } from '../../../theme/theme.constants';

export const AddReimbursementMethod = ({
  isRedirectAvailable = false,
  marketChannelId = 0,
  onReimbursementMethod = () => { },
}) => {
  const { t } = useTranslation('insurance');

  return (
    <div className={styles.reimbursementMethodCard}>
      <div className={styles.reimbursementMethodRow}>
        <span className={styles.reimbursementMethodText}>
          {`${t('noReimbursementMethod')} ${isRedirectAvailable
            ? t('addMethod')
            : ''}`}
        </span>

        {isRedirectAvailable && (
          <LoadingButton
            className={styles.reimbursementMethodAddButton}
            icon={addIcon}
            onClick={onReimbursementMethod}
            text={t('addReimbursementMethod')}
          />
        )}
      </div>

      {marketChannelId === MARKETING_CHANNEL_ID.figo && (
        <DirectDepositBanner
          notMethodSet
          validPolicyStatus={isRedirectAvailable}
        />
      )}
    </div>
  );
};
